import Category from '@/components/Category'
import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutHeading, coreLayoutSection } from '@/constants/measured-scope'
import { CategoryIndexPageSection } from '@/shared/api-generated-types'
import * as styles from './style'

export interface Props extends Partial<CategoryIndexPageSection> {}

const CategoryIndexBlock = ({ title, items }: Props): JSX.Element => {
  return (
    <>
      {title && (
        <header className={coreLayoutHeading}>
          <div className={coreLayoutContainer}>
            <Text
              className="fc-dark"
              tag="h2"
              weight="lg"
              responsiveSize={{
                sm: 'lg',
                lg: 'xl',
              }}
            >
              {title}
            </Text>
          </div>
        </header>
      )}
      {items?.length && (
        <section className={coreLayoutSection}>
          <div className={`${styles.content} ${coreLayoutContainer} grid fc-dark`}>
            {items.map((item, index) => (
              <div key={index}>
                <Category {...item} />
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  )
}

export default CategoryIndexBlock
